export default __webpack_public_path__ + "static/media/nosotros-1.4dd535b3.jpg";